// src/components/ReferralInvitePanel.jsx
import { Box, Text, VStack, Button, useToast } from "@chakra-ui/react";
import ReferralInviteQR from "./ReferralInviteQR";
import useBusinessGuard from "../hooks/useBusinessGuard";

/**
 * ReferralInvitePanel
 * Shows the referral link and QR code for inviting other businesses.
 * Uses UUID businessId (businesses.business_uuid).
 */
export default function ReferralInvitePanel() {
  const { businessIdUuid, loading: authLoading } = useBusinessGuard();
  const toast = useToast();

  if (authLoading || !businessIdUuid) return null;

  const inviteLink = `https://postcode.coupons/signup?ref=${businessIdUuid}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      toast({
        title: "Referral link copied",
        description: "You can now share it with other businesses.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error("[ReferralInvitePanel] Clipboard error:", err);
      toast({
        title: "Copy failed",
        description: "Unable to copy referral link.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      p={4}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      bg="white"
    >
      <Text fontSize="lg" fontWeight="bold" mb={2}>
        📣 Invite Other Businesses
      </Text>

      <VStack spacing={3} align="start">
        <Text fontSize="sm">Your referral link:</Text>

        <Text fontSize="sm" color="blue.600" wordBreak="break-all">
          {inviteLink}
        </Text>

        <Button size="sm" colorScheme="blue" onClick={copyLink}>
          Copy Link
        </Button>

        {/* QR code uses UUID referrerId */}
        <ReferralInviteQR referrerId={businessIdUuid} />
      </VStack>
    </Box>
  );
}
